module.exports = __webpack_public_path__ + "img/team_photo_2.0ea5ea34.png";